module.exports =
{

  _init: function ()
  {

    APPLICATION._APPLICATION.processLinks('#orders', 'FibreNode', 'orders')

    this.checkManualOrder()

  },

  checkManualOrder: function()
  {

    var signup_account_id = parseInt($('#orders').data('signup_account_id'))

    if (0 !== signup_account_id)
    {

      APPLICATION._APPLICATION.customModal(
        APPLICATION._PATH_PREFIX + 'fibre-node/add/' + signup_account_id,
        'FibreNode',
        'add'
      )

    }

  }

}